<template>
  <div class="pos-order-list" ref="container">
    <div class="header"></div>
    <div class="nav acea-row row-around row-middle">
      <div
        class="item"
        :class="where.status == 0 ? 'on' : ''"
        @click="changeStatus(0)"
      >
        待付款
      </div>
      <div
        class="item"
        :class="where.status == 1 ? 'on' : ''"
        @click="changeStatus(1)"
      >
        待发货
      </div>
      <div
        class="item"
        :class="where.status == 2 ? 'on' : ''"
        @click="changeStatus(2)"
      >
        待收货
      </div>
      <div
        class="item"
        :class="where.status == 3 ? 'on' : ''"
        @click="changeStatus(3)"
      >
        待评价
      </div>
      <div
        class="item"
        :class="where.status == 4 ? 'on' : ''"
        @click="changeStatus(4)"
      >
        已完成
      </div>
      <div
        class="item"
        :class="where.status == -3 ? 'on' : ''"
        @click="changeStatus(-3)"
      >
        退款
      </div>
    </div>
    <div class="acea-row row-between-wrapper">
      <div class="search-keyword">
        <span class="iconfont icon-sousuo"></span>
        <input placeholder="请输入搜索关键词" v-model="where.keyword" />
        <span class="iconfont icon-iconfontguanbi" @click="clearKeyword"></span>
      </div>
      <div class="search-btn" @click="init">搜索</div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="order-num">
          <div class="info">
            <div>订单号：{{ item.order_id }}</div>
            <div class="time">下单时间：{{ item.add_time }}</div>
          </div>
          <div @click="toRoute(item.uid)" class="spread-route">推广路线</div>
        </div>
        <div class="pos-order-goods">
          <div
            class="goods acea-row row-between-wrapper"
            v-for="(val, key) in item._info"
            :key="key"
            @click="toDetail(item)"
          >
            <div class="picTxt acea-row row-between-wrapper">
              <div class="pictrue">
                <img :src="val.cart_info.productInfo.image" />
              </div>
              <div class="text acea-row row-between row-column">
                <div class="info line2">
                  {{ val.cart_info.productInfo.store_name }}
                </div>
                <div class="attr" v-if="val.cart_info.productInfo.suk">
                  {{ val.cart_info.productInfo.suk }}
                </div>
              </div>
            </div>
            <div class="money">
              <div class="x-money">￥{{ val.cart_info.productInfo.price }}</div>
              <div class="num">x{{ val.cart_info.cart_num }}</div>
              <div class="y-money">
                ￥{{ val.cart_info.productInfo.ot_price }}
              </div>
            </div>
          </div>
          <div class="order-avatar acea-row row-middle">
            <img class="avatar" :src="item.avatar" />
            <div class="nickname">{{ item.nickname }}</div>
            <div class="tax">税费：{{ item.taxes_price }}</div>
            <div class="express">邮费：￥{{ item.total_postage }}</div>
          </div>
          <div class="user-info acea-row row-middle">
            <div class="info-content">
              <div class="name">
                姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{
                  item.real_name
                }}
              </div>
              <div class="phone">联系方式：{{ item.user_phone }}</div>
            </div>
            <div class="refund" v-if="where.status == -3">
              <div>退款时间</div>
              <div>{{ item.refund_time }}</div>
            </div>
          </div>
        </div>
        <div class="public-total">
          共{{ item.total_num }}件商品，{{
            where.status == 0 ? "应" : "实际"
          }}支付
          <span class="money">￥{{ item.pay_price }}</span>
        </div>
        <div class="operation-button">
          <div
            class="check-express"
            @click="
              $router.push({
                path: '/order/logistics/' + item.order_id
              })
            "
            v-if="(where.status == 2 || where.status == 3) && item.delivery_id"
          >
            查看物流
          </div>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="list.length === 0">
      <div class="pictrue"><img src="@assets/moblie/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import Loading from "@components/moblie/Loading";
import { getPromoterOrderList, getUserInfo } from "../../../../api/user";
export default {
  name: "AdminOrderList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      current: "",
      change: false,
      types: 0,
      where: {
        page: 1,
        limit: 5,
        status: 0,
        keyword: ""
      },
      list: [],
      loaded: false,
      loading: false,
      orderInfo: {},
      status: "",
      userInfo: {}
    };
  },
  watch: {
    "$route.params.types": function(newVal) {
      let that = this;
      if (newVal != undefined) {
        that.where.status = newVal;
        that.init();
      }
    },
    types: function() {
      this.getIndex();
    }
  },
  mounted: function() {
    let that = this;
    getUserInfo().then(res => {
      this.userInfo = res.data;
    });
    that.where.status = that.$route.params.type;
    that.current = "";
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
    more: function(index) {
      if (this.current === index) this.current = "";
      else this.current = index;
    },
    modify: function(item, status) {
      this.change = true;
      this.orderInfo = item;
      this.status = status;
    },
    changeclose: function(msg) {
      this.change = msg;
    },
    init: function() {
      this.list = [];
      this.where.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getIndex();
      this.current = "";
    },
    toRoute(uid) {
      console.log(uid);
      console.log(this.userInfo.certification_type);
      this.$router.push(
        `/user/promote_router?certification_type=${
          this.userInfo.certification_type
        }&uid=${uid}`
      );
    },
    getIndex: function() {
      let that = this;
      if (that.loading || that.loaded) return;
      that.loading = true;
      console.log("查找前");
      console.log(that.where);
      getPromoterOrderList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.list.push.apply(that.list, res.data);
          console.log(that.list);
          that.where.page = that.where.page + 1;
        },
        err => {
          that.$dialog.error(err.msg);
        }
      );
    },
    changeStatus: function(val) {
      if (this.where.status != val) {
        this.where.status = val;
        this.init();
      }
    },
    clearKeyword() {
      this.where.keyword = "";
    },
    doSearch() {
      console.log("sear");
    }
    // toDetail: function(item) {
    //   this.$router.push({ path: "/customer/orderdetail/" + item.order_id });
    // }
  }
};
</script>
<style lang="scss" scoped>
.order-avatar {
  padding-bottom: 0.1rem;
}
.avatar {
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.1rem;
}
.nickname {
  flex-grow: 1;
}
.tax {
  margin-right: 0.1rem;
}
.user-info {
  padding: 0 0.2rem 0.2rem 0.2rem;
}
.operation-button {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
.check-express {
  color: rgb(80, 116, 192);
  border: 1px solid rgb(80, 116, 192);
  border-radius: 2rem;
  padding: 0.1rem 0.3rem;
}
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}
.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.search-keyword {
  width: 84%;
  padding: 0.2rem;
  margin: auto;
  border: solid 1px rgb(111, 139, 216);
  border-radius: 3rem;
  margin-top: 0.2rem;
}
.search-keyword input {
  width: 80%;
  margin-left: 0.2rem;
}
.user-info {
  justify-content: space-between;
}
.refund {
  color: rgb(255, 51, 0);
}
.search-btn {
  margin-right: 0.2rem;
}
</style>
